class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector("header");
    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this.details);
    });

    this.closeEsc = (e) => {
      if (
        e.key === "Escape" &&
        this.classList.contains("open") &&
        !this.querySelector(".mobile-menu__main-mega-menu.open")
      ) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.handleResize = () => {
      if (!this._isMobile && this.details.open) {
        this._forceClose();
      } else if (this._isMobile && !this.details.open) {
        // ensure stale mobile_menu_opened class is removed when moving back to mobile
        this.header.classList.remove("mobile_menu_opened");
      }

      this._setMaxHeightVariable();
    };

    window.addEventListener("resize", this.handleResize);

    this.handleMobileSearchOpen = () => {
      this._open(true);
    };

    document.addEventListener("mobile-search:open", this.handleMobileSearchOpen);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("mobile-search:open", this.handleMobileSearchOpen);
    window.removeEventListener("resize", this.handleResize);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _forceClose() {
    this.classList.remove("open");
    this.details.open = false;
    window.closeDimmer(this);
    window.removeTrapFocus(this.summary);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open(focusSearch) {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.header.classList.add("mobile_menu_opened");  
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openDimmer(this);
      // this.querySelector(".mobile-search__query-input").focus();
      this.style.setProperty(
        "--mobile-menu-top",
        `${this.closest(".header").getBoundingClientRect().bottom}px`,
      );
      this._setMaxHeightVariable();

      if (focusSearch) {
        this.querySelector('input[name="q"]')?.focus();
      }
    });
    window.trapFocus(this.details);
  }

  _close() {
    this.classList.remove("open");
    this.header.classList.remove("mobile_menu_opened");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const onEnd = (e) => {
      if (!('mobileMenuDrawer' in e.target.dataset)) return;

      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      window.unlockScroll(this);
      window.closeDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };
    this.addEventListener("transitionend", onEnd);
  }

  _setMaxHeightVariable() {
    const container = this.querySelector('.header__mobile-menu-content');
    const { height } = container.getBoundingClientRect();
    this.style.setProperty('--mobile-menu-max-content-height', `${height}px`);
  }

  get _isMobile() {
    const header = this.closest(".header");

    if (header && header.classList.contains("header--nav-wraps")) {
      return true;
    }

    return window.matchMedia("(max-width: 1160px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}